export default {
  state: {
    selectedCustomer: {}
  },
  mutations: {
    setSelectedCustomer(state, payload) {
      state.selectedCustomer = payload;
    }
  },
  actions: {
    setSelectedCustomer({ commit }, payload) {
      commit("setSelectedCustomer", payload);
    }
  },
  getters: {
    selectedCustomer(state) {
      return state.selectedCustomer;
    }
  }
};
